import { useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import { Select } from "components/base/Form";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import { useModals } from "ModalProvider";
import { useContext } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { ObjectiveContext } from "./context";
import { FETCH_TEAMS_FOR_OBJECTIVES } from "./graphql";
import ObjectiveForm from "./ObjectiveForm";
import ObjectiveView from "./ObjectiveView";

const TeamDetail = () => {
  const { years } = useContext(ObjectiveContext);
  const { teamId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const params = Object.fromEntries(searchParams.entries());
  const year = params.year === "ALL" ? null : parseInt(params.year, 10);

  const { loading, error, data } = useQuery(FETCH_TEAMS_FOR_OBJECTIVES, {
    variables: { ids: [teamId], year },
  });
  const modal = useModals();

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const team = data.teams[0];

  function addObjective() {
    modal.present({
      title: "Add Objective",
      center: true,
      children: <ObjectiveForm year={year} teamId={teamId} hide={modal.hide} />,
    });
  }

  return (
    <Page
      // title={`${year} / ${team.name} Objectives`}
      title={
        <div className="flex items-center">
          <div>{team.name} Objectives</div>
          <Select
            className="ml-2 text-base py-1 px-2 font-semibold text-blue-600 pl-2"
            value={year || "ALL"}
            onChange={(e) => {
              const value = e.target.value;
              setSearchParams({ ...params, year: value });
            }}
          >
            <option value="ALL">All Years</option>
            {years.map((i) => (
              <option key={i} value={i}>
                {i}
              </option>
            ))}
          </Select>
        </div>
      }
      backTo="./.."
      rightButtons={<Button onClick={addObjective}>+ Add Objective</Button>}
    >
      <div className="p-6 grid grid-cols-1 xl:grid-cols-2 gap-6">
        {team.objectives.map((objective, index) => (
          <div key={index} className="card place-content-stretch">
            <ObjectiveView objective={objective} index={index} />
          </div>
        ))}
      </div>
    </Page>
  );
};

export default TeamDetail;
